import { html } from "lit";
import { HeaderDivider } from "./header-divider";

export const template = (props: HeaderDivider) => {
  return html`
    <div class="header-container"></div>
  `;
};
